import { HeaderGlobalAction } from "@carbon/react";
import React from "react";
const C3ActionButtons = ({ elements, }) => {
    return (React.createElement(React.Fragment, null, elements.map((actionButton) => {
        if ("element" in actionButton) {
            return actionButton.element;
        }
        else {
            return (React.createElement(HeaderGlobalAction, { "aria-label": `Open ${actionButton.label}`, onClick: actionButton.action, isActive: false, key: `${actionButton.label}-key` }, actionButton.icon));
        }
    })));
};
export default C3ActionButtons;
